import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const BarcodeScannerAndroid: React.FC = () => (
  <SEOLandingPage
    title="Barcode Scanner for Android — Free QR & Barcode Reader | Cosmovex"
    metaDescription="Free barcode scanner for Android. Read product barcodes and QR codes instantly with your camera or from a gallery photo, get smart actions on every result, and keep a full scan history. No account needed."
    ogTitle="Barcode Scanner for Android — Scan Barcodes & QR Codes Free"
    h1="Barcode Scanner for Android"
    intro="Point your camera and read it instantly. QR Scanner & Generator reads product barcodes and QR codes the moment they're in frame — then gives you the right action in one tap. Free, with a full history and no account."
    paragraphs={[
      "Open the app and the camera is already looking for codes. It reads common product barcodes and QR codes — web links, Wi-Fi credentials, contact cards, phone numbers, SMS, email addresses and plain text. The result appears as soon as the code fills the frame, with a clear button for whatever it contains: open the link, copy the value, look it up, or save it.",
      "Bad lighting is no problem — a built-in flashlight toggle lights up dim shelves and packaging, and you can scan a barcode straight from a photo already saved in your gallery when the item isn't in front of you.",
      "Everything you scan is saved to a tidy history, so a barcode you checked yesterday is one tap away — no re-scanning. Items can be favorited, searched, copied, shared or deleted, and you can group them into collections to stay organized.",
      "Privacy stays simple: scanning happens on your device with your camera, no account or sign-up is asked for, and the app is light on storage with a clean dark interface. It also generates QR codes — for links, Wi-Fi, contacts and more — so scanning and sharing live in one place.",
    ]}
    features={[
      "Instant camera reading for product barcodes and QR codes",
      "Smart one-tap actions on every result",
      "Scan a barcode from a photo in your gallery",
      "Flashlight toggle for low-light scanning",
      "Full scan history with search and favorites",
      "Collections to keep scanned codes organized",
      "Also generates QR codes for links, Wi-Fi, contacts & text",
      "Works offline · no account · free to download",
    ]}
    howToSteps={[
      { name: "Open the scanner", text: "Launch the app — the camera starts looking for codes right away." },
      { name: "Point at the code", text: "Center the barcode or QR code; it reads the moment it's in frame." },
      { name: "Act on the result", text: "Tap to open a link, copy the value, or save it." },
      { name: "Find it later", text: "Every scan is saved to history and collections for one-tap reuse." },
    ]}
    faqs={[
      { q: "Is the barcode scanner free?", a: "Yes — it's free to download and scan, supported by ads. A one-time Pro upgrade removes ads and unlocks unlimited history." },
      { q: "What can it scan?", a: "Common product barcodes and QR codes — links, Wi-Fi, contacts, phone numbers, SMS, email and text." },
      { q: "Can I scan from a saved photo?", a: "Yes — read a barcode or QR code from any image already in your gallery." },
      { q: "Does it need an account or internet?", a: "No. Scanning runs on your device, works offline, and never asks you to sign up." },
    ]}
    related={[
      { label: "QR Scanner & Generator for Android", path: "/qr-scanner-android", tagline: "Scan and create QR codes" },
      { label: "QR Code Generator for Android", path: "/qr-code-generator-android", tagline: "Make QR codes free" },
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.qrpilot"
    icon="/images/play/qrpilot.png"
    appName="QR Scanner & Generator"
    accentColor="#A8720E"
    canonicalPath="/barcode-scanner-android"
  />
);

export default BarcodeScannerAndroid;
